import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngInputBase } from '../../inputs';

@Component({
  selector: 'ing-checkbox',
  templateUrl: './ing-checkbox.component.html',
  styleUrls: ['./ing-checkbox.component.scss']
})
export class IngCheckBoxComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngInputBase<boolean>;

  constructor() { }

  ngOnInit() {
    this.form.controls[this.input.key].setValue(this.form.controls[this.input.key].value || false);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/ing-checkbox/ing-checkbox.component.ts